import { render } from "./ApprovalDetailPanel.vue?vue&type=template&id=333ca8c0&scoped=true"
import script from "./ApprovalDetailPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailPanel.vue?vue&type=script&lang=js"

import "./ApprovalDetailPanel.vue?vue&type=style&index=0&id=333ca8c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333ca8c0"]])

export default __exports__